import { StyledDocumentContent, StyledDocumentContainer } from './styles';

export const DocumentContent = StyledDocumentContent;
export const DocumentContainer = StyledDocumentContainer;
